import sanitizeHtml from 'sanitize-html';
import _pick from 'lodash.pick';

var rawHtmlProps = {
  tag: {
    type: String,
    default: 'div'
  },
  html: {
    type: [String, Object],
    default: Object
  },
  targetBlankLinks: {
    type: Boolean,
    default: false
  },
  preventImages: {
    type: Boolean,
    default: false
  },
  replace: {
    type: Array,
    default: Array
  },
  allowedTags: {
    type: Array,
    default: Array
  },
  allowedAttributes: {
    type: Object,
    default: Object
  }
};

//

var script$3 = {
  name: 'RawHtml',
  props: rawHtmlProps,
  data() {
    return {
      standardReplace: [[/(<br\s?\/?>)+/g, '<br>']]
    }
  },
  computed: {
    htmlContent() {
      const { before = null, after = null } = typeof this.html === 'string' ? { after: this.html } : this.html;
      return { afterbegin: before, beforeend: after }
    },
    sanitizeAllowedTags() {
      return this.preventImages
        ? [...sanitizeHtml.defaults.allowedTags, ...this.allowedTags]
        : [...sanitizeHtml.defaults.allowedTags, ...this.allowedTags, 'img']
    },
    sanitizeAllowedAttributes() {
      const { img: addImg = [], ...allowedAttributes } = this.allowedAttributes;

      const img = Object.keys(
        addImg.reduce((attrMap, attr) => ({ ...attrMap, [attr]: null }), { src: null, width: null, height: null })
      );

      return { ...sanitizeHtml.defaults.allowedAttributes, ...allowedAttributes, img }
    }
  },
  watch: {
    htmlContent: {
      immediate: true,
      handler: 'renderHTML'
    }
  },
  methods: {
    renderHTML() {
      this.$nextTick(() => {
        const { default: slots = [] } = this.$slots;
        const nodes = slots.map(({ elm }) => elm.cloneNode(true));
        this.$el.innerHTML = '';
        nodes.forEach(node => this.$el.appendChild(node));

        Object.keys(this.htmlContent).forEach(position => {
          const content = this.htmlContent[position];
          if (!content) return

          const renderNode = document.createElement('div');

          renderNode.innerHTML = sanitizeHtml(this.applyReplacements(content), {
            allowedTags: this.sanitizeAllowedTags,
            allowedAttributes: this.sanitizeAllowedAttributes
          });

          if (!this.preventImages) this.convertImgSizeToStyle(renderNode);
          if (this.targetBlankLinks) this.convertExternalLinks(renderNode);

          this.$el.insertAdjacentHTML(position, renderNode.innerHTML);
        });
      });
    },
    convertExternalLinks(renderNode) {
      Array.from(renderNode.querySelectorAll('a[href^="http"]')).forEach(externalLink => {
        externalLink.target = '_blank';
        externalLink.rel = 'noopener';
      });
    },
    convertImgSizeToStyle(renderNode) {
      Array.from(renderNode.querySelectorAll('img')).forEach(img => {
        const { width, height } = img;
        if (width) img.style.width = `${width}px`;
        if (height) img.style.height = `${height}px`;
      });
    },
    applyReplacements(content) {
      const replacements = [...this.standardReplace, ...this.replace];

      return replacements.reduce((str, grep) => {
        const [match, sub = ''] = Array.isArray(grep) ? grep : [grep];
        const regex = match.constructor.name === 'RegExp' ? match : new RegExp(match, 'g');
        return str.replace(regex, sub)
      }, content)
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "Element",
    { staticClass: "raw-html", attrs: { tag: _vm.tag } },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    undefined,
    undefined,
    undefined
  );

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

rawHtmlProps.html;
    var props = _objectWithoutProperties(rawHtmlProps, ["html"]);

var WrapHtml = {
  name: 'WrapHtml',
  props: props,
  render: function render(h) {
    var _this$$slots$default = _slicedToArray(this.$slots.default, 1),
        _this$$slots$default$ = _this$$slots$default[0];

    _this$$slots$default$ = _this$$slots$default$ === void 0 ? {} : _this$$slots$default$;
    var text = _this$$slots$default$.text;
    if (!text) return null;
    return h('RawHtml', {
      props: _objectSpread2(_objectSpread2({}, props), {}, {
        html: text
      })
    });
  }
};

var Element = {
  name: 'Element',
  functional: true,
  props: {
    tag: {
      type: String,
      default: null
    },
    is: {
      type: String,
      default: 'div'
    }
  },
  render: function render(h, _ref) {
    var children = _ref.children,
        data = _ref.data,
        props = _ref.props;
    return h(props.tag || props.is, {
      class: [data.staticClass, data.class]
    }, children);
  }
};

//
//
//
//
//
//

var script$2 = {
  name: 'Icon',
  props: {
    id: { type: String, required: true }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { ref: "svgRef", staticClass: "icon" }, [
    _c("use", { attrs: { "xlink:href": "#" + _vm.id } })
  ])
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

var GlobalComponents = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Element: Element,
  Icon: __vue_component__$2,
  RawHtml: __vue_component__$3,
  WrapHtml: WrapHtml
});

var kebabToCamel = function kebabToCamel() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.replace(/-+([^-])/g, function ($m, $1) {
    return $1.toUpperCase();
  });
};

var camelToKebab = function camelToKebab() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.replace(/(.)([A-Z])/g, function ($m, $1, $2) {
    return "".concat($1, "-").concat($2);
  }).toLowerCase();
};

var camelKebab = function camelKebab(str) {
  return {
    get camel() {
      return kebabToCamel(str);
    },

    get kebab() {
      return camelToKebab(str);
    }

  };
};

camelKebab.toCamel = kebabToCamel;
camelKebab.toKebab = camelToKebab;

var createFormatter = function createFormatter(char, defaultTag) {
  return function () {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTag;
    return str.replace(new RegExp("\\".concat(char, "([^").concat(char, "]+)\\").concat(char), 'g'), "<".concat(tag, ">$1</").concat(tag, ">"));
  };
};

var bold = createFormatter('*', 'strong');
var italic = createFormatter('_', 'em');
var strike = createFormatter('~', 's');
var formatInline = {
  bold: bold,
  italic: italic,
  strike: strike,
  star: bold,
  strong: bold,
  em: italic,
  lodash: italic,
  underscore: italic,
  strikethrough: strike,
  create: function create(char, tag) {
    return createFormatter(char, tag);
  }
};

var keywordPropValidator = (function () {
  for (var _len = arguments.length, keywords = new Array(_len), _key = 0; _key < _len; _key++) {
    keywords[_key] = arguments[_key];
  }

  return {
    type: String,
    default: String,
    validator: [].includes.bind(keywords)
  };
});

var isString = function isString(value) {
  return typeof value === 'string';
};

var isFunction = function isFunction(value) {
  return typeof value === 'function';
};

var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};

var isNumber = function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
};

var isArray = function isArray(value) {
  return Array.isArray(value);
};

var isObject = function isObject(value) {
  return value !== null && !Array.isArray(value) && _typeof(value) === 'object';
};

var isNullOrUndefined = function isNullOrUndefined() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return value === null;
};

var isRegExp = function isRegExp(value) {
  var safeValue = value || '';
  return safeValue.constructor.name === RegExp.name;
};

var isEmpty = function isEmpty() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (isNullOrUndefined(value)) return true;
  var isValueObject = isObject(value);
  var isImpliedValue = isNumber(value) || isFunction(value) || value === true;
  var isEmptyObject = isValueObject && !isRegExp(value) && Object.keys(value).length === 0;
  return isEmptyObject || !isImpliedValue && !isValueObject && !value.length;
};

var check = function check(value) {
  return {
    get isString() {
      return isString(value);
    },

    get isFunction() {
      return isFunction(value);
    },

    get isBoolean() {
      return isBoolean(value);
    },

    get isNumber() {
      return isNumber(value);
    },

    get isArray() {
      return isArray(value);
    },

    get isObject() {
      return isObject(value);
    },

    get isNullOrUndefined() {
      return isNullOrUndefined(value);
    },

    get isRegExp() {
      return isRegExp(value);
    },

    get isEmpty() {
      return isEmpty(value);
    }

  };
};

check.isString = isString;
check.isFunction = isFunction;
check.isBoolean = isBoolean;
check.isNumber = isNumber;
check.isArray = isArray;
check.isObject = isObject;
check.isNullOrUndefined = isNullOrUndefined;
check.isRegExp = isRegExp;
check.isEmpty = isEmpty;

var mergeClasses = function mergeClasses() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return classNames.filter(check.isEmpty);
};

var getConditionalModifiers = function getConditionalModifiers(props) {
  return Object.keys(props).reduce(function (modifiers, key) {
    return _objectSpread2(_objectSpread2({}, modifiers), {}, _defineProperty({}, "-".concat(camelKebab.toKebab(key)), props[key]));
  }, {});
};

var ContentClassNamesMixin = {
  props: {
    classNames: {
      type: Object,
      default: Object
    }
  },
  computed: {
    rootClassName: function rootClassName() {
      var _this = this;

      var _this$$options$modifi = this.$options.modifiers,
          modifiers = _this$$options$modifi === void 0 ? [] : _this$$options$modifi;
      return function () {
        for (var _len2 = arguments.length, permanentModifiers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          permanentModifiers[_key2] = arguments[_key2];
        }

        return ['content'].concat(permanentModifiers, [getConditionalModifiers(_pick(_this, modifiers))]);
      };
    }
  },
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    var contentClassNames = this.$options.contentClassNames;
    if (!contentClassNames) return;
    contentClassNames.forEach(function (elDef) {
      var isLoop = /\(\)$/.test(elDef);
      var el = elDef.replace(/\(\)$/, '');
      var elementClass = "content__".concat(el);

      _this2.$options.computed[elementClass] = function () {
        var className = this.classNames[el];
        if (!isLoop) return mergeClasses(elementClass, className);
        return function (index) {
          var parsedClassName = check.isFunction(className) ? className(index) : className;
          return mergeClasses(elementClass, parsedClassName);
        };
      };
    });
  }
};

//

var script$1 = {
  name: 'ContentText',
  mixins: [ContentClassNamesMixin],
  modifiers: ['center'],
  contentClassNames: ['legend', 'title', 'row', 'column()', 'footer'],
  props: {
    center: { type: Boolean, default: false },
    legend: { type: String, default: null },
    title: { type: String, default: null },
    content: { type: Array, default: Array }
  },
  computed: {
    shouldDisplay() {
      return !!(this.title || this.legend || this.content.length)
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.shouldDisplay
    ? _c("section", { class: _vm.rootClassName("-text") }, [
        _vm.legend
          ? _c("h2", { class: _vm.content__legend }, [
              _vm._v(_vm._s(_vm.legend))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.title
          ? _c("h3", { class: _vm.content__title }, [_vm._v(_vm._s(_vm.title))])
          : _vm._e(),
        _vm._v(" "),
        _vm.content.length
          ? _c(
              "div",
              { class: _vm.content__row },
              _vm._l(_vm.content, function(col, index) {
                return _c("RawHtml", {
                  key: col,
                  class: _vm.content__column(index),
                  attrs: { html: col }
                })
              }),
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$slots.default.length && _vm.center
          ? _c("footer", { class: _vm.content__footer }, [_vm._t("default")], 2)
          : _vm._e()
      ])
    : _vm._e()
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

var content = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ContentText: __vue_component__$1
});

//
//
//
//
//
//
//
//

var script = {
  name: 'DropDown',
  props: {
    isOpen: { type: Boolean, required: true },
    tag: { type: String, default: 'div' },
    contentTag: { type: String, default: 'div' },
    contentClass: { type: [String, Array, Object], default: Array },
    transitionKey: { type: [String, Number, Array, Object], default: null }
  },
  data() {
    return { height: this.isOpen ? 'auto' : 0 }
  },
  computed: {
    className() {
      const contentClass = Array.isArray(this.contentClass) ? this.contentClass : [this.contentClass];
      return ['dropdown__content', { '-open': this.isOpen }, ...contentClass]
    },
    style() {
      return {
        height: !Number(this.height) ? this.height : `${this.height}px`
      }
    }
  },
  watch: {
    isOpen(isOpen, wasOpen) {
      if (isOpen === wasOpen) return
      if (wasOpen) this.height = this.$refs.content.clientHeight;
      else this.resetAfterTransition();

      this.$nextTick(() => {
        setTimeout(() => {
          this.height = this.isOpen ? this.$refs.content.clientHeight : 0;
        }, 10);
      });
    },
    transitionKey(to, from) {
      if (to === from || !this.isOpen) return
      this.height = this.$refs.content.clientHeight;
      this.resetAfterTransition();

      this.$nextTick(() => {
        setTimeout(() => {
          this.height = this.isOpen ? this.$refs.content.clientHeight : 0;
        }, 10);
      });
    }
  },
  methods: {
    resetAfterTransition() {
      this.$once('transition-end', () => {
        if (this.isOpen) this.height = 'auto';
      });
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.tag,
    {
      tag: "Element",
      staticClass: "dropdown",
      style: _vm.style,
      on: {
        transitionend: function($event) {
          return _vm.$emit("transition-end")
        }
      }
    },
    [
      _c(
        _vm.contentTag,
        { ref: "content", tag: "Element", class: _vm.className },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

var ContentSections = _objectSpread2({}, content);

var index = (function (Vue) {
  Object.values(GlobalComponents).forEach(function (component) {
    return Vue.component(component.name, component);
  });
});

export { ContentSections, __vue_component__$1 as ContentText, __vue_component__ as DropDown, camelKebab, check, index as default, formatInline, keywordPropValidator };
